/* eslint-disable no-script-url */
import React, { useEffect, useState, useContext } from 'react';
import { ThemeContext } from 'styled-components';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';

export default ({
  ariaLabel,
  branding,
  children,
  className,
  id,
  targetId,
  themeType,
  variant,
}) => {

  const theme = useContext(ThemeContext);
  const largeUp = theme.largeUp();
  const [isDesktop, setIsDesktop] = useState(largeUp);

  useEffect(() => {
    if (largeUp !== isDesktop) {
      setIsDesktop(largeUp);
    }
  }, [largeUp, isDesktop]);

  const nmxScroll = (e, elId) => {
    e.preventDefault();
    // gathering desktop sticky nav height
    const headerEl = document.querySelector('#nmx-header > .nmx-container');
    const headerElHeight = headerEl.clientHeight;
    // gathering mobile nav height
    const mobileHeaderEl = document.querySelector('.nmx-header-logo-container');
    const mobileHeaderElHeight = mobileHeaderEl.clientHeight;
    // get targeted section element
    const el = document.getElementById(elId);
    // setting offset for desktop
    let elPosY;
    if(isDesktop){
      elPosY = window.scrollY + el.getBoundingClientRect().top - headerElHeight;
    }else {
      elPosY = window.scrollY + el.getBoundingClientRect().top - mobileHeaderElHeight;
    }

    window.scroll({
      top: elPosY,
      behavior: 'smooth',
    });

    setTimeout(() => {
      const focusableEls = Array.prototype.slice.call(el.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]):not(.no-query), [tabindex="0"]'));
      const firstFocusableEl = focusableEls[0];
      if(firstFocusableEl){
        firstFocusableEl.focus({ preventScroll: true });
      }
    }, 500);
  };

  return (
    <Link
      ariaLabel={ariaLabel}
      branding={branding}
      className={className}
      id={id}
      linkUrl=''
      onClick={(e) => {nmxScroll(e, targetId); }}
      themeType={themeType}
      variant={variant}>
      {children}
    </Link>
  );
};
